module.exports = __webpack_public_path__ + "static/media/b7.fd4c489.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengxiaoyue/b7.mp3
// module id = VO8t
// module chunks = 0